import styled from '@emotion/styled';

export const VideoCard = styled.div`
  margin-top: 8px;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
`;
